import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BellOff, ArrowRight } from "lucide-react";
import { api, tokens } from "@/lib/api";

export const SubscriptionBanner = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!tokens.get()) return;
    api.get("/me").then(setUser).catch(() => setUser(null));
  }, []);

  if (!user || user.subscription_active) return null;

  return (
    <div className="border-b border-amber-200 bg-amber-50" data-testid="subscription-banner">
      <div className="mx-auto flex max-w-5xl items-center gap-3 px-5 py-2.5 sm:py-3">
        <BellOff className="h-4 w-4 shrink-0 text-amber-700" />
        <p className="min-w-0 flex-1 text-xs text-amber-900 sm:text-sm">
          <span className="font-semibold">Your SMS alerts are off.</span>
          <span className="hidden sm:inline">
            {" "}You can browse every recall here, but we won't text you until you subscribe.
          </span>
        </p>
        <Link
          to="/settings#sms-alerts"
          data-testid="subscription-banner-cta"
          className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-amber-700 px-4 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-amber-800 sm:px-5 sm:py-2 sm:text-sm"
        >
          Turn on <span className="hidden sm:inline">alerts</span>
          <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </div>
  );
};
